/**
 * @generated SignedSource<<aa8c16b7824295ec63c1bd04051bf4e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutVatReverseCharge_transaction$data = {
  readonly canBeVatReverseCharge: boolean | null;
  readonly hasBuyerReverseChargeAction: boolean | null;
  readonly priceBookName: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutVatReverseChargeCheckbox_transaction">;
  readonly " $fragmentType": "CheckoutVatReverseCharge_transaction";
};
export type CheckoutVatReverseCharge_transaction$key = {
  readonly " $data"?: CheckoutVatReverseCharge_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutVatReverseCharge_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutVatReverseCharge_transaction",
  "selections": [
    {
      "alias": "hasBuyerReverseChargeAction",
      "args": [
        {
          "kind": "Literal",
          "name": "actionCode",
          "value": "BUYER_REVERSE_CHARGE_ELIGIBLE"
        }
      ],
      "kind": "ScalarField",
      "name": "hasAction",
      "storageKey": "hasAction(actionCode:\"BUYER_REVERSE_CHARGE_ELIGIBLE\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canBeVatReverseCharge",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceBookName",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutVatReverseChargeCheckbox_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "941563afd4ac23488567812c106f81de";

export default node;
